import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

import messages from './messages/ContactPersonSelector_messages';

import { InputGroup, Label, Select } from '../../components/Form';

const propTypes = {
  disabled: PropTypes.bool,
  intl: intlShape.isRequired,
  labelKeys: PropTypes.array,
  onChange: PropTypes.func,
  options: PropTypes.array,
  selected: PropTypes.object,
  valueKey: PropTypes.string,
};

const defaultProps = {
  disabled: false,
  labelKeys: ['firstName', 'lastName'],
  onChange: () => {},
  options: [],
  selected: null,
  valueKey: 'id',
};

const ContactPersonSelector = ({
  disabled, intl, labelKeys, onChange, options, selected, valueKey
}) => {
  const selectContactPerson = evnt => {
    const { target: { value } } = evnt;
    if (value !== 'none') {
      const contactPerson = options.find(cp => `${cp[valueKey]}` === value);
      onChange({ contactPerson });
    }
  }
  return (
    <InputGroup>
      <Label htmlFor='contact-person-selector'>
        <FormattedMessage { ...messages.title } />
      </Label>
      <Select
        disabled={disabled}
        id='contact-person-selector'
        onChange={selectContactPerson}
        value={selected ? selected[valueKey] : ''}
      >
        <option value='none'>
          {intl.formatMessage(messages.emptyContactPersonLabel)}
        </option>
        {options.map(o =>
          <option
            key={o[valueKey]}
            value={o[valueKey]}
          >
            {labelKeys.map(lk => o[lk]).join(' ')}
          </option>
        )}
      </Select>
    </InputGroup>
  );
};

ContactPersonSelector.propTypes = propTypes;
ContactPersonSelector.defaultProps = defaultProps;

export default injectIntl(ContactPersonSelector);
